import { connect, useDispatch } from 'react-redux';
import spacetime from 'spacetime';
import { Dispatch, SetStateAction, useCallback, useEffect, useMemo } from 'react';

import { IKnmStatus } from 'APIPackage/CatalogsModule/interfaces/IKnmStatus';
import { KnmTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmTypeCodesEnum';
import { ApprovedTypesEnum } from 'APIPackage/KnmModule/enums/ApprovedTypesEnum';
import { ApproveRequiredTypesEnum } from 'APIPackage/KnmModule/enums/ApproveRequiredTypesEnum';
import {
  getIsPlanErknmStatusUnderConsideration,
  getIsPlanErknmStatusConsidered,
  getIsPlanErknmStatusApproved,
} from 'APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { IKnmRejectReasonTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmRejectReasonTypeSelectOption';
import { IKnmTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmTypeSelectOption';
import {
  approvedSelectOptions,
  approvedSelectOptionsOld,
  planTypeApprovedSelectOptions,
  planTypeApprovedSelectRenamedOptions,
  planTypeRejectAppealedSelectOptions,
} from 'KnmErknmPackage/MainModule/constants/approvedSelectOptions';
import {
  APPROVE_NOTE_APPEAL_BLOCK_ID,
  APPROVE_NOTE_BLOCK_ID,
  APPROVED_BLOCK_ID,
  PROSECUTOR_ORGANIZATION_BLOCK_ID,
  REJECTED_REASON_TYPE_BLOCK_ID,
} from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { KNM_APPROVE_INFO } from 'CorePackage/MainModule/routes/routes';
import {
  getErknmKnmRejectReasonTypesSelectOptions,
  getKnmStatusCode,
  getKnmIsErknmStatusApproving,
  getKnmIsErknmStatusFillInProcess,
  getKnmIsErknmStatusReadyForApprove,
  getKnmIsErknmStatusRejectAppealed,
  getKnmIsErknmStatusRejected,
  getKnmFormRef,
  getKnmIsErknmStatusCommentsExist,
  getKnmIsErknmStatusTypeWaitingCarryOut,
  getKnmIsInitialData,
  getKnmIsSeveralOrganizations,
  getKnmIsApproveFieldsEnabled,
  getKnmIsNew,
  getKnmHistoryChanges,
  getKnmDataCreated,
  getKnmIsWatchOnly,
  getKnmIsErknmStatusTypeCompleted,
  getKnmIsErknmStatusNotApprove,
  getKnmDataCreatedBy,
  getKnmProsecutorOrganization,
  getKnmDataErknmApproveApproved,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { IApprovedSelectOption } from 'KnmErknmPackage/MainModule/interfaces/IApprovedSelectOption';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { getPlanListPlanErknmStatus } from 'PlanListPackage/MainModule/selectors/planListSelectors';
import { CheckboxField } from 'UIPackage/MainModule/components/CheckboxField';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { TextareaField } from 'UIPackage/MainModule/components/TextareaField';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';
import { KnmAttachmentsList } from 'KnmPackage/MainModule/components/KnmAttachmentsList';
import { Section } from 'UIPackage/FormModule/components/Section';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IKnmHistoryChanges } from 'KnmPackage/MainModule/interfaces/IKnmHistoryChanges';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { knmGetHistoryChanges, knmSetHistoryChangesIsOn } from 'KnmPackage/MainModule/actions/knmActions';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { getAdminFetchSettings } from 'PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';

import styles from './ErknmApproveInfoDetails.module.scss';
import { ErknmApproveInfoDocument } from './ErknmApproveInfoDocument';
import {
  getUserProfileIsTest,
  getUserRoleIsProsecutor,
  getUserRoleIsSuperProsecutor,
  getUserRoleIsSupervisor,
} from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { IKnmErknmFormChangePlanReason } from '../../MainModule/interfaces/IKnmErknmFormChangePlanReason';
import { ErknmFieldMark } from '../../MainModule/components/ErknmFieldMark';
import { IUserOrganisationSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';
import { getAccountProsecutorOrganizationsWithDistrictSelectOptions } from '../../../CorePackage/AccountModule/selectors/accountSelectors';
import { IKnmUsername } from '../../../APIPackage/KnmModule/interfaces/IKnmUsername';
import { IProsecutorOffice } from '../../../APIPackage/KnmModule/interfaces/IProsecutorOffice';

interface IErknmApproveInfoDetailsProps {
  approveAppeal: boolean | undefined;
  approveRequired: ApproveRequiredTypesEnum | undefined;
  approved: ApprovedTypesEnum | undefined;
  changePlanReason: IKnmErknmFormChangePlanReason[] | undefined;
  isApproveNoteFieldEnabledByStatus: boolean;
  isDisableFieldByPreApproveStatuses: boolean;
  isDisableFieldByRejectStatuses: boolean;
  planId: string | undefined;
  setIsApproveNoteFieldEnabledByStatus: Dispatch<SetStateAction<boolean>>;
  typeCode: IKnmTypeSelectOption['code'] | undefined;
  watchOnlyExtended: boolean;
}

interface IErknmApproveInfoDetailsStoreProps {
  created: string | null | undefined;
  formRef: IKnmFormRef | undefined;
  isApprovingFieldsEnabled: boolean;
  isInitialData?: boolean;
  isKnmStatusApproving: boolean;
  isKnmStatusCommentsExist: boolean;
  isKnmStatusCompleted: boolean;
  isKnmStatusFillInProcess: boolean;
  isKnmStatusNotApprove: boolean;
  isKnmStatusReadyForApprove: boolean;
  isKnmStatusRejectAppealed: boolean;
  isKnmStatusRejected: boolean;
  isKnmStatusTypeWaitingCarryOut: boolean;
  isNewKnm: boolean;
  isProsecutor: boolean;
  isSeveralOrganizations?: boolean;
  isSuperProsecutor: boolean;
  isSupervisor: boolean;
  isWatchOnly: boolean;
  knmHistoryChanges?: IKnmHistoryChanges;
  knmPlanStatus: ErknmPlanStatusesEnum | undefined;
  knmRejectReasonTypesSelectOptions: IKnmRejectReasonTypeSelectOption[] | undefined;
  settings: IAdminSetting[] | undefined;
  statusCode: IKnmStatus['code'] | undefined;
  userProsecutorOrganisationsSelectOptions: IUserOrganisationSelectOption[];
  knmCreatedBy: IKnmUsername | undefined;
  prosecutorOrganization: IProsecutorOffice | null | undefined;
  isTestUser: boolean;
  knmApprovedFromData: ApprovedTypesEnum | null | undefined;
}

const ErknmApproveInfoDetailsWithoutStore = ({
  approveAppeal,
  approveRequired,
  approved,
  changePlanReason,
  isApproveNoteFieldEnabledByStatus,
  isDisableFieldByPreApproveStatuses,
  isDisableFieldByRejectStatuses,
  planId,
  setIsApproveNoteFieldEnabledByStatus,
  typeCode,
  watchOnlyExtended,
  created,
  formRef,
  isApprovingFieldsEnabled,
  isInitialData,
  isKnmStatusApproving,
  isKnmStatusCommentsExist,
  isKnmStatusCompleted,
  isKnmStatusFillInProcess,
  isKnmStatusNotApprove,
  isKnmStatusReadyForApprove,
  isKnmStatusRejectAppealed,
  isKnmStatusRejected,
  isKnmStatusTypeWaitingCarryOut,
  isNewKnm,
  isProsecutor,
  isSeveralOrganizations,
  isSuperProsecutor,
  isSupervisor,
  isWatchOnly,
  knmHistoryChanges,
  knmPlanStatus,
  knmRejectReasonTypesSelectOptions,
  settings,
  statusCode,
  userProsecutorOrganisationsSelectOptions,
  knmCreatedBy,
  prosecutorOrganization,
  isTestUser,
  knmApprovedFromData,
}: IErknmApproveInfoDetailsProps & IErknmApproveInfoDetailsStoreProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const isKnmPlanStatusUnderConsideration: boolean = getIsPlanErknmStatusUnderConsideration(knmPlanStatus);
  const isKnmPlanStatusConsidered: boolean = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isKnmPlanStatusApproved: boolean = getIsPlanErknmStatusApproved(knmPlanStatus);
  const isProsecutorOrSuperProsecutor = isProsecutor || isSuperProsecutor;

  const isPlanType = typeCode === KnmTypeCodesEnum.PP;
  const isUnplanType = typeCode === KnmTypeCodesEnum.VP;
  const isApproveRequired = approveRequired === ApproveRequiredTypesEnum.REQUIRED;
  const isEnableProsecutorOrgField = !statusCode || isKnmStatusFillInProcess || isKnmStatusReadyForApprove;
  const isDisableFieldForKno = isSupervisor && (isKnmStatusFillInProcess || isKnmStatusReadyForApprove);
  const isDisableForProsecutorByApprovingStatus = isProsecutor && isKnmStatusApproving;
  const isDisableForProsecutorByRejectAppealedStatus = isProsecutor && isKnmStatusRejectAppealed;

  const isUnlockForProsecutorByCommentsExist =
    isProsecutor && isPlanType && isKnmPlanStatusUnderConsideration && isKnmStatusCommentsExist;

  const isDisableInitialFields = (isSeveralOrganizations ? false : isInitialData) || (!isNewKnm ? !!planId : false);
  const isDisabledForProsecutorByPlanStatusUnderConsideration = isProsecutor && isKnmPlanStatusUnderConsideration;
  const isApprovedFieldEnabled =
    !isWatchOnly &&
    isProsecutor &&
    (isKnmPlanStatusUnderConsideration ||
      (!isKnmPlanStatusUnderConsideration &&
        (isKnmStatusRejectAppealed || (isKnmStatusApproving && (isUnplanType || isKnmPlanStatusApproved)))));
  const isApproveNoteFieldEnabled =
    isApprovedFieldEnabled &&
    isApproveNoteFieldEnabledByStatus &&
    approved !== ApprovedTypesEnum.APPROVED &&
    approved !== ApprovedTypesEnum.ON_APPROVAL &&
    approved !== ApprovedTypesEnum.APPROVED_WITH_REMARK;

  const isDisableFieldsInPlanUnderConsideration =
    (isKnmStatusApproving || isKnmStatusCommentsExist || isKnmStatusTypeWaitingCarryOut || isKnmStatusRejected) &&
    isKnmPlanStatusUnderConsideration;

  const isDisableFieldsInPlanUnderConsiderationForSupervisor = isDisableFieldsInPlanUnderConsideration && isSupervisor;
  const isDisableApproveAppealForProsecutor = isProsecutor && isKnmStatusRejected;

  const isEnabledForSuperProsecutor =
    (isSuperProsecutor &&
      isPlanType &&
      (isKnmStatusApproving ||
        (isKnmPlanStatusConsidered &&
          (isKnmStatusRejectAppealed ||
            isKnmStatusRejected ||
            isKnmStatusCommentsExist ||
            isKnmStatusTypeWaitingCarryOut)) ||
        (isKnmPlanStatusApproved &&
          (isKnmStatusRejected || isKnmStatusCompleted || isKnmStatusTypeWaitingCarryOut)))) ||
    (isUnplanType &&
      isApproveRequired &&
      (isKnmStatusApproving || isKnmStatusNotApprove || isKnmStatusTypeWaitingCarryOut || isKnmStatusCompleted));

  const webDocuments = formRef?.current.getState().values.webDocuments;

  const handleChangeApproved = useCallback(
    (value: IApprovedSelectOption) => {
      if (!(value.id === ApprovedTypesEnum.DENIED || value.id === ApprovedTypesEnum.DENIED_PLANNED)) {
        formRef?.current.change('rejectReasonType');
        formRef?.current.change('rejectReasonNote');
        formRef?.current.change('approveDateRejectReason');
      }
      setIsApproveNoteFieldEnabledByStatus(true);

      if (
        (approved === ApprovedTypesEnum.APPROVED_WITH_REMARK && value.id === ApprovedTypesEnum.DENIED) ||
        (approved === ApprovedTypesEnum.DENIED && value.id === ApprovedTypesEnum.APPROVED_WITH_REMARK)
      ) {
        formRef?.current.change('approveNote');
        formRef?.current.change('approveRemarks');
      }

      if (value.id === ApprovedTypesEnum.DENIED || value.id === ApprovedTypesEnum.DENIED_PLANNED) {
        if (isPlanType && isProsecutorOrSuperProsecutor && isKnmStatusRejectAppealed) {
          formRef?.current.change('wasRejected', true);
        }
      }
    },
    [formRef, approved],
  );

  const isShow22 = isLaterThanAdminSetting(created, settings, AdminSettingCodesEnum.KNM_VALIDATION_4_1_22_STARTS_FROM);

  const isErvkProsecutorOrganizationStartFrom = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.ERVK_PROSECUTOR_ORGANIZATION_4_1_15_STARTS_FROM,
  );

  const isShowProsecutorOrganization =
    knmCreatedBy?.username === 'SMEV' && !prosecutorOrganization?.ervkUuid && isErvkProsecutorOrganizationStartFrom;

  /**
   * Запрашиваем историю КНМ, если паспорт в статусе Готов к согласованию и зашел прокурор
   */
  useEffect(() => {
    if (isProsecutorOrSuperProsecutor && isKnmStatusApproving && !knmHistoryChanges) {
      dispatch(knmSetHistoryChangesIsOn(true));
      dispatch(knmGetHistoryChanges());
    }
  }, [knmHistoryChanges, isProsecutorOrSuperProsecutor, isKnmStatusApproving]);

  const isShow4131 = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_4_1_31_STARTS_FROM,
  );

  /**
   * Надо ли заблокировать поля согласования для прокурора на 4 часа от смены статуса
   */
  const isDisabledForProsecutorByLockTime = useMemo(() => {
    if (
      isShow4131 &&
      knmHistoryChanges &&
      knmHistoryChanges.execution &&
      knmHistoryChanges.execution.length &&
      isProsecutorOrSuperProsecutor &&
      isKnmStatusApproving &&
      isUnplanType &&
      !isTestUser
    ) {
      const setting = settings?.find(st => st.code === AdminSettingCodesEnum.KNM_LOCK_TIME_4_1_31);
      const lockTime = setting?.value ? parseInt(setting.value, 10) : 4 * 60;
      const dateWithoutTimeZone = knmHistoryChanges.execution[0].eventDate.replaceAll('Z', '');

      return spacetime().epoch - spacetime(dateWithoutTimeZone, 'Europe/Moscow').epoch < lockTime * 60 * 1000;
    }

    return false;
  }, [
    knmHistoryChanges,
    isProsecutorOrSuperProsecutor,
    isKnmStatusApproving,
    isShow4131,
    isUnplanType,
    settings,
    settings,
  ]);

  const isValidateChangePlanReason =
    isProsecutorOrSuperProsecutor &&
    isKnmPlanStatusApproved &&
    isKnmStatusApproving &&
    changePlanReason?.some(
      item =>
        item?.reasonChangeType?.code === 'RSN_CHNG_PP_XII' ||
        item?.reasonChangeType?.code === 'RSN_CHNG_PP_XXI' ||
        item?.reasonChangeType?.code === 'RSN_CHNG_PP_XX',
    );
  const isRsnCngPPXXII = changePlanReason?.some(item => item?.reasonChangeType?.code === 'RSN_CHNG_PP_XXII');

  const hasGuidWithUndefinedReasonInApprovingKnm =
    isProsecutorOrSuperProsecutor &&
    isKnmPlanStatusApproved &&
    isKnmStatusApproving &&
    !!changePlanReason?.some(
      item => (item?.reasonChangeType === undefined && item?.guid) || approved !== 'ON_APPROVAL',
    );

  /**
   * Значения для выбора "Решение по заявлению"
   */
  const approvedOptions = useMemo(() => {
    let options: IApprovedSelectOption[] = approvedSelectOptionsOld;

    if (isShow22) {
      if (isPlanType && isValidateChangePlanReason) {
        options = planTypeApprovedSelectOptions;
      } else if (isPlanType) {
        if (isProsecutorOrSuperProsecutor && isKnmStatusRejectAppealed) {
          options = planTypeRejectAppealedSelectOptions;
        } else {
          options = planTypeApprovedSelectRenamedOptions;
        }
      } else {
        options = approvedSelectOptions;
      }
    } else if (isPlanType) {
      options = planTypeApprovedSelectOptions;
    }

    if (!isKnmPlanStatusUnderConsideration) {
      return options.filter(item => item.value !== ApprovedTypesEnum.APPROVED_WITH_REMARK);
    }

    return options;
  }, [
    isShow22,
    isPlanType,
    isKnmPlanStatusUnderConsideration,
    isKnmStatusRejectAppealed,
    isProsecutorOrSuperProsecutor,
  ]);

  const isFiledDisabled = (fieldName: string) => {
    const isAfterApproval =
      knmApprovedFromData !== ApprovedTypesEnum.ON_APPROVAL && !isUnlockForProsecutorByCommentsExist;

    const isApproveNoteFieldDisabled: boolean =
      !isApproveNoteFieldEnabled ||
      isDisableFieldsInPlanUnderConsiderationForSupervisor ||
      isDisableForProsecutorByRejectAppealedStatus ||
      (isKnmStatusCommentsExist && !isUnlockForProsecutorByCommentsExist) ||
      isKnmStatusReadyForApprove ||
      isAfterApproval;

    const isApprovedFiledDisabled: boolean =
      (!isApprovedFieldEnabled ||
        isDisableFieldsInPlanUnderConsiderationForSupervisor ||
        !isApprovingFieldsEnabled ||
        isDisableForProsecutorByRejectAppealedStatus ||
        isDisabledForProsecutorByLockTime ||
        isAfterApproval) &&
      !isValidateChangePlanReason &&
      !isUnlockForProsecutorByCommentsExist;

    const isCommonFiledDisabled: boolean =
      ((!isDisabledForProsecutorByPlanStatusUnderConsideration && watchOnlyExtended) ||
        isDisableFieldForKno ||
        isDisableFieldByPreApproveStatuses ||
        isDisableForProsecutorByRejectAppealedStatus ||
        isDisableFieldByRejectStatuses ||
        isDisableFieldsInPlanUnderConsiderationForSupervisor ||
        !isApprovingFieldsEnabled ||
        isAfterApproval) &&
      !isUnlockForProsecutorByCommentsExist;

    switch (fieldName) {
      case 'approveNote':
        return isSuperProsecutor
          ? !isEnabledForSuperProsecutor && isApproveNoteFieldDisabled
          : isApproveNoteFieldDisabled;
      case 'approved':
        return (
          isRsnCngPPXXII ||
          (isSuperProsecutor
            ? !isEnabledForSuperProsecutor && isApprovedFiledDisabled && !hasGuidWithUndefinedReasonInApprovingKnm
            : isApprovedFiledDisabled && !hasGuidWithUndefinedReasonInApprovingKnm)
        );
      case 'rejectReasonNote':
        return isSuperProsecutor
          ? isWatchOnly ||
              (!isEnabledForSuperProsecutor && (isCommonFiledDisabled || isDisabledForProsecutorByLockTime))
          : isWatchOnly || isCommonFiledDisabled || isDisabledForProsecutorByLockTime;
      case 'approveDateRejectReason':
        return isSuperProsecutor
          ? isWatchOnly ||
              (!isEnabledForSuperProsecutor &&
                (isCommonFiledDisabled || isDisableFieldsInPlanUnderConsiderationForSupervisor))
          : isWatchOnly || isCommonFiledDisabled || isDisableFieldsInPlanUnderConsiderationForSupervisor;
      case 'approveNumberDecision':
      case 'approveDateDecision':
      case 'approveFioSigner':
      case 'approveTitleSigner':
      case 'rejectReasonType':
      case 'approveFile':
        return (
          isRsnCngPPXXII ||
          (isSuperProsecutor
            ? isWatchOnly ||
              (!isEnabledForSuperProsecutor &&
                ((isCommonFiledDisabled && !hasGuidWithUndefinedReasonInApprovingKnm) ||
                  isDisableFieldsInPlanUnderConsiderationForSupervisor ||
                  isDisabledForProsecutorByLockTime))
            : isWatchOnly ||
              (isCommonFiledDisabled && !hasGuidWithUndefinedReasonInApprovingKnm) ||
              isDisableFieldsInPlanUnderConsiderationForSupervisor ||
              isDisabledForProsecutorByLockTime)
        );

      default:
        return isWatchOnly;
    }
  };

  return (
    <Section
      title={
        <>
          Сведения о согласовании проведения КНМ с органами прокуратуры
          <ErknmFieldMark sectionName="approveInfo" />
        </>
      }
      id={KNM_APPROVE_INFO}
      type="group"
    >
      <Row>
        <FieldBlock label="Наименование прокуратуры" id={PROSECUTOR_ORGANIZATION_BLOCK_ID} color="black">
          <SelectInputField
            id="prosecutorOrganizationErknm"
            name="prosecutorOrganizationErknm"
            options={userProsecutorOrganisationsSelectOptions}
            isClearable
            isSearchable={!isShowProsecutorOrganization}
            disabled={
              (!isNewKnm ||
                !isEnableProsecutorOrgField ||
                watchOnlyExtended ||
                isDisableForProsecutorByApprovingStatus ||
                isDisableForProsecutorByRejectAppealedStatus ||
                isDisableFieldByRejectStatuses ||
                isDisableInitialFields ||
                isDisableFieldsInPlanUnderConsideration) &&
              !isShowProsecutorOrganization
            }
            size="medium"
          />
        </FieldBlock>
      </Row>

      {isPlanType && (
        <Row>
          <FieldBlock
            label={
              <>
                Комментарий
                <ErknmFieldMark fieldName="approveNote" />
              </>
            }
            id={APPROVE_NOTE_BLOCK_ID}
            color="black"
          >
            <TextareaField
              inputClassName={styles.NoteFieldInput}
              id="approveNote"
              name="approveNote"
              disabled={isFiledDisabled('approveNote')}
            />
          </FieldBlock>
        </Row>
      )}
      {isApproveRequired && (
        <>
          <Row>
            <FieldBlock
              label={
                <>
                  Решение по заявлению
                  <ErknmFieldMark fieldName="approved" />
                </>
              }
              id={APPROVED_BLOCK_ID}
              color="black"
              size="half"
            >
              <SelectInputField
                id="approved"
                name="approved"
                options={approvedOptions}
                size="medium"
                disabled={isFiledDisabled('approved')}
                isClearable={false}
                onChange={handleChangeApproved}
              />
            </FieldBlock>
            <FieldBlock size="half">
              <Row>
                <FieldBlock
                  label={
                    <>
                      Номер решения
                      <ErknmFieldMark fieldName="approveNumberDecision" />
                    </>
                  }
                  color="black"
                  size="half"
                >
                  <TextInputField
                    id="approveNumberDecision"
                    name="approveNumberDecision"
                    disabled={isFiledDisabled('approveNumberDecision')}
                  />
                </FieldBlock>
                <FieldBlock
                  label={
                    <>
                      Дата решения
                      <ErknmFieldMark fieldName="approveDateDecision" />
                    </>
                  }
                  color="black"
                  size="half"
                >
                  <DatePickerField
                    id="approveDateDecision"
                    name="approveDateDecision"
                    disabled={isFiledDisabled('approveDateDecision')}
                  />
                </FieldBlock>
              </Row>
            </FieldBlock>
          </Row>
          <Row>
            <FieldBlock
              label={
                <>
                  Кем принято решение
                  <ErknmFieldMark fieldName="approveFioSigner" />
                </>
              }
              color="black"
              size="half"
            >
              <TextareaField
                id="approveFioSigner"
                name="approveFioSigner"
                disabled={isFiledDisabled('approveFioSigner')}
              />
            </FieldBlock>
            <FieldBlock
              label={
                <>
                  Должность лица, подписавшего решение
                  <ErknmFieldMark fieldName="approveTitleSigner" />
                </>
              }
              color="black"
              size="half"
            >
              <TextareaField
                id="approveTitleSigner"
                name="approveTitleSigner"
                disabled={isFiledDisabled('approveTitleSigner')}
              />
            </FieldBlock>
          </Row>

          {isPlanType &&
            (approved === ApprovedTypesEnum.DENIED_PLANNED || approved === ApprovedTypesEnum.DENIED) &&
            !isProsecutorOrSuperProsecutor && (
              <CheckboxField
                className={styles.ApproveAppealField}
                labelClassName={styles.ApproveAppealFieldLabel}
                id="approveAppeal"
                name="approveAppeal"
                label="Решение обжаловано"
                size="medium"
                type="checkbox"
                theme="system"
                disabled={
                  isWatchOnly ||
                  (!isDisabledForProsecutorByPlanStatusUnderConsideration && watchOnlyExtended) ||
                  isDisableFieldForKno ||
                  isDisableForProsecutorByApprovingStatus ||
                  isDisableFieldByPreApproveStatuses ||
                  isDisableForProsecutorByRejectAppealedStatus ||
                  (isSupervisor && isKnmStatusRejected && !isKnmPlanStatusConsidered) ||
                  isDisableFieldsInPlanUnderConsideration ||
                  isDisableApproveAppealForProsecutor
                }
              />
            )}

          {approveAppeal && (
            <Row>
              <FieldBlock label="Сведения об обжаловании" id={APPROVE_NOTE_APPEAL_BLOCK_ID} color="black">
                <TextareaField
                  id="approveNoteAppeal"
                  name="approveNoteAppeal"
                  disabled={
                    isWatchOnly ||
                    (!isDisabledForProsecutorByPlanStatusUnderConsideration && watchOnlyExtended) ||
                    isDisableFieldForKno ||
                    isDisableForProsecutorByApprovingStatus ||
                    isDisableForProsecutorByRejectAppealedStatus ||
                    isDisableFieldsInPlanUnderConsideration
                  }
                />
              </FieldBlock>
            </Row>
          )}

          {(approved === ApprovedTypesEnum.DENIED || approved === ApprovedTypesEnum.DENIED_PLANNED) && (
            <>
              {!isPlanType && (
                <Row>
                  <FieldBlock
                    label={
                      <>
                        Причина отказа
                        <ErknmFieldMark fieldName="rejectReasonType" />
                      </>
                    }
                    color="black"
                    id={REJECTED_REASON_TYPE_BLOCK_ID}
                  >
                    <SelectInputField
                      id="rejectReasonType"
                      name="rejectReasonType"
                      placeholder="Выберите причину отказа"
                      options={knmRejectReasonTypesSelectOptions}
                      disabled={isFiledDisabled('rejectReasonType')}
                      size="medium"
                    />
                  </FieldBlock>
                </Row>
              )}
              <Row>
                <FieldBlock label="Мотивировка отказа (при необходимости)" color="black">
                  <TextareaField
                    id="rejectReasonNote"
                    name="rejectReasonNote"
                    disabled={isFiledDisabled('rejectReasonNote')}
                  />
                </FieldBlock>
              </Row>
              {!isShow4131 && (
                <Row>
                  <FieldBlock label="Дата отказа" color="black" size="col-4">
                    <DatePickerField
                      id="approveDateRejectReason"
                      name="approveDateRejectReason"
                      disabled={isFiledDisabled('approveDateRejectReason')}
                    />
                  </FieldBlock>
                </Row>
              )}
            </>
          )}
          {webDocuments?.length ? (
            <div className={styles.ApproveFioSignerFieldBlock}>
              <div className="shared-label-block">
                <label className="shared-field-label" htmlFor="approveFioSigner">
                  Документы из АИК &quot;Надзор-Web&quot;
                </label>
              </div>
              <KnmAttachmentsList name="webDocuments" removeField={undefined} isWatchOnly />
            </div>
          ) : (
            isShow4131 && (
              <ErknmApproveInfoDocument
                disableToAdd={isFiledDisabled('approveFile')}
                name="approveFile"
                watchOnly={isFiledDisabled('approveFile')}
                formRef={formRef}
              />
            )
          )}
        </>
      )}
    </Section>
  );
};

const mapStateToProps = (state: IRootState): IErknmApproveInfoDetailsStoreProps => ({
  created: getKnmDataCreated(state),
  isApprovingFieldsEnabled: getKnmIsApproveFieldsEnabled(state),
  isInitialData: getKnmIsInitialData(state),
  isKnmStatusApproving: getKnmIsErknmStatusApproving(state),
  isKnmStatusCommentsExist: getKnmIsErknmStatusCommentsExist(state),
  isKnmStatusCompleted: getKnmIsErknmStatusTypeCompleted(state),
  isKnmStatusFillInProcess: getKnmIsErknmStatusFillInProcess(state),
  isKnmStatusNotApprove: getKnmIsErknmStatusNotApprove(state),
  isKnmStatusReadyForApprove: getKnmIsErknmStatusReadyForApprove(state),
  isKnmStatusRejectAppealed: getKnmIsErknmStatusRejectAppealed(state),
  isKnmStatusRejected: getKnmIsErknmStatusRejected(state),
  isKnmStatusTypeWaitingCarryOut: getKnmIsErknmStatusTypeWaitingCarryOut(state),
  isNewKnm: getKnmIsNew(state),
  isProsecutor: getUserRoleIsProsecutor(state),
  isSuperProsecutor: getUserRoleIsSuperProsecutor(state),
  isSeveralOrganizations: getKnmIsSeveralOrganizations(state),
  isSupervisor: getUserRoleIsSupervisor(state),
  isWatchOnly: getKnmIsWatchOnly(state),
  formRef: getKnmFormRef(state),
  knmHistoryChanges: getKnmHistoryChanges(state),
  knmRejectReasonTypesSelectOptions: getErknmKnmRejectReasonTypesSelectOptions(state),
  knmPlanStatus: getPlanListPlanErknmStatus(state),
  settings: getAdminFetchSettings(state),
  statusCode: getKnmStatusCode(state),
  userProsecutorOrganisationsSelectOptions: getAccountProsecutorOrganizationsWithDistrictSelectOptions(state),
  knmCreatedBy: getKnmDataCreatedBy(state),
  prosecutorOrganization: getKnmProsecutorOrganization(state),
  isTestUser: getUserProfileIsTest(state),
  knmApprovedFromData: getKnmDataErknmApproveApproved(state),
});

export const ErknmApproveInfoDetails = connect(mapStateToProps)(ErknmApproveInfoDetailsWithoutStore);
